
<h1 mat-dialog-title >Report Type</h1>

<div mat-dialog-content style="overflow: hidden; padding: 5px; margin: 5px;" >

		
	<mat-card >
		<mat-card-content>
		<div >
				<h3 class="report-font">

				Please select the report type you want to export
				</h3>	
			<div  class="report-types report-font">
			<input type="checkbox" (change)="reportType = '1'" [checked]="reportType === '1'"> Campaign Plan report
            <input type="checkbox" (change)="reportType = '2'" [checked]="reportType === '2'"> Production Plan report
            
		</div>

		 </div>
		 <div class="export" >
		 <button mat-stroked-button (click)="exportToExcel()">Export</button>
		</div>
		</mat-card-content>
		</mat-card >
	
</div>


